export default __webpack_public_path__ + "static/media/paragraph_mode1.32710a62.png";